module.exports = __webpack_public_path__ + "ca09a4aeb418197b277843348474af45.fbx";